export default "https://d3fbpisbzpk8wt.cloudfront.net/202511712253/receiptUploading-bundle-e6830bacb7ca615bc6f24748f61c84da.gif";